import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';

// @TODO utilize theme-provider to config predefined style (mean - from settings)

export const TITLE1_TEXT_STYLE = { fontSize: 20, fontWeight: 700 };
export const Title1 = styled(Typography).attrs({
  textStyle: TITLE1_TEXT_STYLE
})``;

export const TITLE2_TEXT_STYLE = { fontSize: 16, fontWeight: 700 };
export const Title2 = styled(Typography).attrs({
  textStyle: TITLE2_TEXT_STYLE,
  lineHeight: '22px'
})``;

export const BUTTON_TEXT_STYLE = { fontSize: 15, fontWeight: 700 };

export const BODY1_TEXT_STYLE = { fontSize: 15, fontWeight: 400 };
export const Body1 = styled(Typography).attrs({
  textStyle: BODY1_TEXT_STYLE
})``;
export const BODY2_TEXT_STYLE = { fontSize: 15, fontWeight: 500 };
export const Body2 = styled(Typography).attrs({
  textStyle: BODY2_TEXT_STYLE
})``;

export const CAPTION_TEXT_STYLE = { fontSize: 13 };
export const CAPTION_BOLD_STYLE = { fontSize: 13, fontWeight: 500 };
export const Caption = styled(Typography).attrs({
  textStyle: CAPTION_TEXT_STYLE
})``;
